<template>
    <div>
        <div class="seo">
            <seo-title content="Volkswagen Klub København - Din volkswagen familie"></seo-title>
            <seo-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-description>
            <seo-author content="Deveo ApS"></seo-author>
            <seo-keywords content="VW, VW København, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"></seo-keywords>
            <seo-og-title content="Volkswagen Klubbens netværksmøde - Skal du med?"></seo-og-title>
            <seo-og-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-og-description>
            <seo-og-site-name content="VW København Erhvervscenter"></seo-og-site-name>
            <seo-google-name content="Volkswagen Klubbens netværksmøde - Skal du med?"></seo-google-name>
            <seo-google-description content="Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."></seo-google-description>
            <seo-google-image content=""></seo-google-image>
        </div>
        <intro videoId="7bGJbhDr7TM"
               bg="/static/images/focus-1.jpg"
               buttonText="DATO KOMMER SNART">
            <div slot="title">
                VOLKSWAGEN KØBENHAVN<br>ERHVERVSKLUB
            </div>
            <div slot="subtitle">
                Deltag i Volkswagen ErhvervsCenter Københavns netværksmøde og udvid dit netværk på en uformel måde.
            </div>
        </intro>
        <!--<countdown deadline="2018/06/14 06:30"></countdown>-->
        <boxes intro="Volkswagen ErhvervsCenter Københavns netværksmøde"
               firstText="God stemning & nye bekendtskaber"
               firstPicture="/static/images/focus-1.jpg"
               secondText="Minvolkswagen: Din vej til flådestyring"
               secondPicture="/static/images/focus-2.jpg"
               thirdText="Innovativ bilindretning"
               thirdPicture="/static/images/focus-3.jpg"
        ></boxes>
        <practical-info title="Dette skal du glæde dig til">
            <div slot="text">
                For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.
                <br><br>
                Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.
                <br><br>
                Vi starter tidligt om morgenen, så det ikke går ud over din arbejdstid. Der serveres morgenmad og en velsmagende kop friskbrygget kaffe. Vi glæder os til at se dig.
            </div>
            <div slot="address">
                Volkswagen København<br>
                Banevingen 9<br>
                2200 København N
            </div>
            <div slot="datetime">
                Dato kommer snart
            </div>
            <div slot="partners">
                <!--<a  href="http://www.sortimo.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/Sortimo.png" width="120"/>
                </a>-->
                <a href="https://deveo.dk/" target="_blank" rel="noopener nofollow">
                    <img src="/static/images/deveo-logo.png" width="120"/>
                </a>
                <!--<a href="http://www.rtt.dk/produkter/Bilindretning " target="_blank" rel="noopener nofollow">
                    <img src="/static/images/rtt-logo.jpg" width="60"/>
                </a>-->
                <a href="https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html" target="_blank" rel="noopener" style="margin-right:15px;">
                    <span style="font-family:vw-bold">Volkswagen</span> Finans
                </a>
                <a href="https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html" target="_blank" rel="noopener">
                    <span style="font-family:vw-bold">Volkswagen</span> Forsikring
                </a>
            </div>
        </practical-info>
        <promo title="Transporter"
               staticCarId="1"
               buttonLink="https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#"
               buttonText="Online showroom"
        >
            <div slot="text">
                Transporter med sikkerheds- eller infotainmentpakke uden merpris.
            </div>
        </promo>
        <statement-and-price title="Gå herfra inspireret og med nye bekendtskaber"
                             price="GRATIS"
                             mainEmployeeImage="/static/images/mg.jpg"
                             mainEmployeeName="Martin Gill"
                             mainEmployeeTitle="Salgschef, Volkswagen ErhvervsCenter København"
                             secondaryEmployeeImage="/static/images/rv.jpg"
                             secondaryEmployeeName="Runi Villebæk"
                             secondaryEmployeeTitle="Salgsrådgiver, Volkswagen ErhvervsCenter København"
        >
            <div slot="statement">
                Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.
                <br><br>
                Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.
                <br><br>
                Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.
                <br><br>
                Vi glæder os til at byde dig velkommen i Volkswagen familien.
            </div>
            <li class="check-mark" slot="benefits">Adgang til arrangement</li>
            <li class="check-mark" slot="benefits">Mad & drikke</li>
            <li class="check-mark" slot="benefits">Networking</li>
        </statement-and-price>
        <registration eventId="ddb054affa69ce60f11597144"
                      eventToken="4243223ffc"
                      :disabled="true"
                      name="Koebenhavn"
        ></registration>
        <contact title="Volkswagen ErhvervsCenter København"
                 phone="+45 43 22 30 12"
                 facebookUrl="VolkswagenCopenhagen"
        ></contact>
    </div>
</template>
<script>
    import Intro from '../../../../../src/components/home-sections/intro'
    import Countdown from '../../../../../src/components/home-sections/countdown'
    import Boxes from '../../../../../src/components/home-sections/boxes'
    import PracticalInfo from '../../../../../src/components/home-sections/practical-info'
    import Promo from '../../../../../src/components/home-sections/promo'
    import statementAndPrice from '../../../../../src/components/home-sections/statement-and-price'
    import Registration from '../../../../../src/components/home-sections/registration'
    import Contact from '../../../../../src/components/home-sections/contact'

    export default {
        name: 'Koebenhavn',
        created () {
            window.fbq('trackCustom', 'Koebenhavn')
        },
        components: {
            'intro': Intro,
            'countdown': Countdown,
            'boxes': Boxes,
            'practical-info': PracticalInfo,
            'promo': Promo,
            'statement-and-price': statementAndPrice,
            'registration': Registration,
            'contact': Contact
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?28e95647